export const isInBuilder = () => {
  if (typeof window === 'undefined') return false;

  try {
    return window.self !== window.top;
  } catch {
    // Catch browser security error, in case builder.io
    // block cross-site origin in the future
    return true;
  }
};
